module.exports = __webpack_public_path__ + "static/media/img4.72045849.svg";